/**
 * @generated SignedSource<<0bda26f230d2386f81a30515ae7a1887>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedCreatorsResultContainer_items$data = ReadonlyArray<{
  readonly item: {
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"FavoritesProvider_item" | "SharedItemTile_item" | "useSbSharedItemTracking_item">;
  } | null;
  readonly " $fragmentType": "SbSharedCreatorsResultContainer_items";
}>;
export type SbSharedCreatorsResultContainer_items$key = ReadonlyArray<{
  readonly " $data"?: SbSharedCreatorsResultContainer_items$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedCreatorsResultContainer_items">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbSharedCreatorsResultContainer_items",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FavoritesProvider_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useSbSharedItemTracking_item"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "isTrade",
              "variableName": "isTrade"
            },
            {
              "kind": "Variable",
              "name": "priceBookName",
              "variableName": "priceBookName"
            },
            {
              "kind": "Variable",
              "name": "showSeller",
              "variableName": "showSeller"
            }
          ],
          "kind": "FragmentSpread",
          "name": "SharedItemTile_item"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchResult",
  "abstractKey": null
};

(node as any).hash = "d4a2ea157f0d25c2983f1bbdffbb6621";

export default node;
